import { t } from "i18next";

// Sarf madde yardımcıları. Stok ve miktarlar her zaman KULLANIM biriminde (ml, adet…) tutulur;
// ambalaj içeriği (packageSize) çevrim katsayısıdır: 1 şişe = 10 ml.

export const MOVEMENT_TYPE = { ENTRY: 1, USAGE: 2, WASTE: 3, ADJUSTMENT: 4 }

export const MOVEMENT_REASON = { LOST: 1, DAMAGED: 2, EXPIRED: 3, COUNT_DIFFERENCE: 4, PACKAGE_REMAINDER: 5, GENERAL_USE: 6, OTHER: 9 }

export const USAGE_METHOD = { MANUAL: 1, AUTO_INJECTOR: 2 }

export const usageMethodLabel = (method) => ({
    [USAGE_METHOD.MANUAL]: t('Manual'),
    [USAGE_METHOD.AUTO_INJECTOR]: t('Automatic Injector'),
}[method] || '')

export const LINE_SOURCE = { AUTO: 1, MANUAL: 2 }

export const LINE_STATUS = { PLANNED: 0, CONFIRMED: 1, REVISED: 2, CANCELLED: 3 }

export const movementTypeLabel = (type) => ({
    [MOVEMENT_TYPE.ENTRY]: t('Stock Entry'),
    [MOVEMENT_TYPE.USAGE]: t('Usage'),
    [MOVEMENT_TYPE.WASTE]: t('Waste'),
    [MOVEMENT_TYPE.ADJUSTMENT]: t('Adjustment'),
}[type] || type)

export const movementTypeColor = (type) => ({
    [MOVEMENT_TYPE.ENTRY]: 'green',
    [MOVEMENT_TYPE.USAGE]: 'blue',
    [MOVEMENT_TYPE.WASTE]: 'volcano',
    [MOVEMENT_TYPE.ADJUSTMENT]: 'purple',
}[type])

export const reasonLabel = (reason) => ({
    [MOVEMENT_REASON.LOST]: t('Lost'),
    [MOVEMENT_REASON.DAMAGED]: t('Damaged'),
    [MOVEMENT_REASON.EXPIRED]: t('Expired'),
    [MOVEMENT_REASON.COUNT_DIFFERENCE]: t('Count Difference'),
    [MOVEMENT_REASON.PACKAGE_REMAINDER]: t('Package Remainder (Waste)'),
    [MOVEMENT_REASON.GENERAL_USE]: t('General Use'),
    [MOVEMENT_REASON.OTHER]: t('Other'),
}[reason] || '')

// Kullanıcının seçebildiği sebepler (ambalaj artığı yalnız tamamlama onayında otomatik yazılır)
export const SELECTABLE_REASONS = [
    MOVEMENT_REASON.LOST,
    MOVEMENT_REASON.DAMAGED,
    MOVEMENT_REASON.EXPIRED,
    MOVEMENT_REASON.COUNT_DIFFERENCE,
    MOVEMENT_REASON.OTHER,
]

export const lineStatusLabel = (status) => ({
    [LINE_STATUS.PLANNED]: t('Planned'),
    [LINE_STATUS.CONFIRMED]: t('Confirmed'),
    [LINE_STATUS.REVISED]: t('Revised'),
    [LINE_STATUS.CANCELLED]: t('Set to 0'),
}[status] || '')

const numberFormat = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 3 })

export const formatQty = (value) => numberFormat.format(Number(value) || 0)

/** "98 şişe — 980 ml". Adet bazlı (ambalaj = 1, aynı birim) sarfta tek birim yazılır. */
export const formatStock = (quantity, consumable) => {
    const qty = Number(quantity) || 0
    const size = Number(consumable?.packageSize) || 0
    const usage = `${formatQty(qty)} ${consumable?.unit || ''}`.trim()
    if (!size || (size === 1 && consumable?.packageUnit === consumable?.unit))
        return usage
    return `${formatQty(qty / size)} ${consumable?.packageUnit || ''} — ${usage}`
}

/**
 * Sunucudaki ConsumableDeduction.Calculate ile aynı formül (satır bazında).
 * Bölünemez: açılan ambalaj = ⌈kullanılan ÷ içerik⌉, artan fire. Bölünebilir: tam kullanılan, fire yok.
 */
export const calculateDeduction = (quantity, packageSize, isDivisible) => {
    const qty = Number(quantity) || 0
    const size = Number(packageSize) || 0
    if (qty <= 0 || size <= 0)
        return { usage: 0, waste: 0, packages: 0, total: 0 }
    if (isDivisible)
        return { usage: qty, waste: 0, packages: qty / size, total: qty }
    // Kayan nokta (0.1 + 0.2) yüzünden ⌈⌉ fazladan ambalaj saymasın diye 3 haneye yuvarlanır.
    const packages = Math.ceil(Math.round(qty / size * 1000) / 1000)
    const waste = Math.round((packages * size - qty) * 1000) / 1000
    return { usage: qty, waste, packages, total: qty + waste }
}

/** Onay ekranı ve randevu sekmesindeki kısa düşüm açıklaması. */
export const describeDeduction = (quantity, consumable) => {
    const d = calculateDeduction(quantity, consumable?.packageSize, consumable?.isDivisible)
    if (d.total <= 0)
        return t('No stock movement')
    if (consumable?.isDivisible)
        return t('{{qty}} will be deducted', { qty: `${formatQty(d.usage)} ${consumable.unit}` })
    const opened = `${formatQty(d.packages)} ${consumable.packageUnit}`
    return d.waste > 0
        ? t('{{opened}} will be deducted, {{waste}} waste', { opened, waste: `${formatQty(d.waste)} ${consumable.unit}` })
        : t('{{opened}} will be deducted', { opened })
}
